/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.extension.rpc.ApplicationsRpc
 */

export const getAvailableAppsRpc = {
  serviceName: 'com.hubspot.video.conference.extension.rpc.ApplicationsRpc',
  rpcName: 'getAvailableApps',
  auth: 'app',
  fingerprint: 'SL1GLv8l4j7y-uOfxQtXnJ5o4pZ7dwL8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAvailableCurrentUserAppsRpc = {
  serviceName: 'com.hubspot.video.conference.extension.rpc.ApplicationsRpc',
  rpcName: 'getAvailableCurrentUserApps',
  auth: 'app',
  fingerprint: '9A8c6INOijny-uOfxQtXnJ5o4pZ7dwL8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};